import type { JobResult } from './types';

/**
 * In-memory hand-off between the run screen and the result screen.
 *
 * A finished job already carries its whole map, so navigating to the result
 * route should not fetch it again. The cache is per page load and deliberately
 * small: the result route falls back to `GET /v1/analyses/{id}` whenever the entry
 * is missing, which is what happens on a reload or a link from the history.
 */
const CACHE_LIMIT = 4;
const cache = new Map<string, JobResult>();

export function rememberResult(result: JobResult): void {
  cache.set(result.map_id, result);
  while (cache.size > CACHE_LIMIT) {
    const oldest = cache.keys().next();
    if (oldest.done) break;
    cache.delete(oldest.value);
  }
}

export function recallResult(mapId: string): JobResult | null {
  return cache.get(mapId) ?? null;
}

export function forgetResult(mapId: string): void {
  cache.delete(mapId);
}
